module.exports = __webpack_public_path__ + "media/images/current-location-a404909867f33f3415fe04890da0c5a5.png";